import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import api from '../../services/api';

export const fetchConversations = createAsyncThunk(
  'conversations/fetchConversations',
  async ({ q = '', filter = '', limit = 100 }, { rejectWithValue }) => {
    try {
      const response = await api.get('/?action=conversations-list', { params: { q, filter, limit } });
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Error');
    }
  }
);

export const fetchConversationMessages = createAsyncThunk(
  'conversations/fetchMessages',
  async ({ conversationId }, { rejectWithValue }) => {
    try {
      const response = await api.get('/?action=conversations-messages', { params: { conversation_id: conversationId } });
      return response.data.data;
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Error');
    }
  }
);

export const moderateConversation = createAsyncThunk(
  'conversations/moderate',
  async ({ conversationId, status }, { rejectWithValue }) => {
    try {
      const response = await api.post('/?action=conversations-moderate', { conversation_id: conversationId, status });
      return { conversationId, status: response.data.data.status };
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Error');
    }
  }
);

const conversationsSlice = createSlice({
  name: 'conversations',
  initialState: {
    items: [],
    selectedConversation: null,
    messages: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
    clearSelectedConversation: (state) => {
      state.selectedConversation = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchConversations.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchConversations.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchConversations.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchConversationMessages.fulfilled, (state, action) => {
        state.messages = action.payload;
      })
      .addCase(moderateConversation.fulfilled, (state, action) => {
        const conv = state.items.find(c => c.id === action.payload.conversationId);
        if (conv) conv.status = action.payload.status;
      });
  },
});

export const { clearError, clearSelectedConversation } = conversationsSlice.actions;
export default conversationsSlice.reducer;
